import React from 'react';
import { Outlet } from 'react-router-dom';

function InvestmentsLayout() {
  return (
    <div className="space-y-6">
      <Outlet />
    </div>
  );
}

export default InvestmentsLayout;